
function scrollTo(element, speed, horizontal = false) {

	if (element instanceof jQuery) element = element.get(0);
	if (!element || !element.nodeType) return false;

	var $html = $('html, body');
	var rect = element.getBoundingClientRect();
	var currentScroll = (window.pageYOffset || document.documentElement.scrollTop)  - (document.documentElement.clientTop || 0);

	// get top/left relative to document, not window
	var top = rect.top + (window.scrollY  || window.pageYOffset || document.documentElement.scrollTop) - document.documentElement.clientTop;
	var left = rect.left + (window.scrollX  || window.pageXOffset || document.documentElement.scrollLeft) - document.documentElement.clientLeft;

	var distance = Math.abs(currentScroll - top);
	var time = distance/speed;

	var animationProperties = horizontal ? {
		scrollTop : top,
		scrollLeft : left
	} : {
		scrollTop : top
	};

	// cancel scroll on user scroll
	$html.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function() {
		$html.stop();
	});

	$html.animate({ scrollTop: top }, time, function() {
		$html.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
	});
}

export default scrollTo;